<img class="hidden md:block mx-auto md:mb-10 rounded-xl"  src="assets/advertbanner3.png" alt="">
<div class="md:flex md:justify-evenly md:gap-4">
    <div class="md:w-full md:border-e-4 border-lrpTicketBlue border-opacity-20">
        <app-auth-login />
    </div>
    <div class="w-full">
        <div class="text-center mt-20">
            <div class="w-full mb-6">
                Not already a member? Sign up to <span class="text-lg font-semibold tracking-wide text-lrpTicketBlue">LRP</span> <span class="font-semibold"> Tickets</span> today!
            </div>
            <div class="w-full mb-4">
                <h2>How does it work?</h2>
                <p>All your favourite event organisers in one place!</p>
            </div>
            <button class="primaryButton mx-auto w-full md:w-1/2" routerLink="/register">Sign Up Today</button>
        </div>
    </div>
</div>